// @ts-nocheck

/**
 * * `hardcover` - Hardcover
 * `softcover` - Softcover
 */
export type CoverTypeEnum = typeof CoverTypeEnum[keyof typeof CoverTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CoverTypeEnum = {
  hardcover: "hardcover",
  softcover: "softcover",
} as const;
